import React from 'react';
import { FaBookOpen, FaSpinner } from 'react-icons/fa';
import loaderSvg from '../../assets/loader.svg';

const LoadingStates = {
  // Main dashboard loading state
  DashboardLoading: () => (
    <div className="min-h-screen flex items-center justify-center">
      <img src={loaderSvg} alt="Loading" className="w-16 h-16" />
    </div>
  ),

  // Course content loading state
  CourseContentLoading: () => (
    <div className="min-h-screen flex items-center justify-center">
      <img src={loaderSvg} alt="Loading" className="w-16 h-16" />
    </div>
  ),

  // No path assigned state
  NoPathAssigned: () => (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-8">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 text-center max-w-md">
        <div className="w-16 h-16 bg-[#1086a4] bg-opacity-10 rounded-full flex items-center justify-center mx-auto mb-4">
          <FaBookOpen className="w-8 h-8 text-[#1086a4]" />
        </div>
        <h2 className="text-xl font-bold text-[#054581] mb-3">No Learning Path Assigned</h2>
        <p className="text-[#1e2d40] mb-6 leading-relaxed">
          You haven't been assigned to a learning path yet. Please contact your instructor or complete the onboarding process to get started.
        </p>
        <div className="space-y-2 text-sm text-gray-500">
          <p>Need help? Contact your program administrator.</p>
          <p>Or check back later for updates.</p>
        </div>
      </div>
    </div>
  ),

  // Generic loading spinner
  Spinner: ({ size = "h-8 w-8", color = "border-[#1086a4]" }) => (
    <div className={`animate-spin rounded-full border-b-2 ${color} ${size}`}></div>
  ),

  // Generic empty state
  EmptyState: ({ 
    icon: Icon = FaBookOpen, 
    title = "No Data Available", 
    message = "There's nothing to display at the moment.",
    action = null 
  }) => (
    <div className="text-center text-[#1e2d40] py-8">
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <Icon className="w-8 h-8 text-gray-400" />
      </div>
      <p className="text-lg font-medium mb-2">{title}</p>
      <p className="text-sm text-gray-500 mb-4">{message}</p>
      {action && action}
    </div>
  ),

  // Loading state with custom message
  LoadingWithMessage: () => (
    <div className="flex justify-center py-8">
      <img src={loaderSvg} alt="Loading" className="w-10 h-10" />
    </div>
  ),

  // Error state
  ErrorState: ({ 
    title = "Something went wrong", 
    message = "An error occurred while loading the data.",
    onRetry = null 
  }) => (
    <div className="text-center text-[#1e2d40] py-8">
      <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg className="w-8 h-8 text-red-500" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
        </svg>
      </div>
      <p className="text-lg font-medium mb-2">{title}</p>
      <p className="text-sm text-gray-500 mb-4">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="bg-[#1086a4] hover:bg-[#054581] text-white px-4 py-2 rounded-lg font-medium transition-colors"
        >
          Try Again
        </button>
      )}
    </div>
  )
};

export default LoadingStates; 